import { render, staticRenderFns } from "./LatestPublicationsBlock.vue?vue&type=template&id=2f16d172"
import script from "./LatestPublicationsBlock.vue?vue&type=script&lang=js"
export * from "./LatestPublicationsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports